import {
  Component,
  ComponentRef,
  computed,
  effect,
  EventEmitter,
  inject,
  OnDestroy,
  OnInit,
  signal,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { BreadcrumbService } from '../../layout/breadcrumb/breadcrumb.service';
import { DailyRouteUserIdService } from '../../core/services/daily-route-user-id.service';
import { select, Store } from '@ngrx/store';
import { filter, map, switchMap, take, takeUntil, withLatestFrom } from 'rxjs/operators';
import { inputIsNotNull, inputIsNotNullOrUndefined, inputIsNotUndefined } from '../../data-access/input-is-not-null-or-undefined';
import { SelectedUserService } from '../../layout/selected-user.service';
import { GoogleMap, GoogleMapsModule, MapInfoWindow, MapMarker } from '@angular/google-maps';
import {
  BehaviorSubject,
  combineLatest,
  debounceTime,
  distinctUntilChanged,
  first,
  fromEvent,
  fromEventPattern,
  Observable,
  of,
  pairwise,
  ReplaySubject,
  shareReplay,
  startWith,
  Subject,
  tap,
} from 'rxjs';
import { TerraDraw, TerraDrawFreehandMode, TerraDrawRenderMode } from 'terra-draw';
import { TerraDrawGoogleMapsAdapter } from 'terra-draw-google-maps-adapter';
import { AccountCategory } from '../../models/account-category.schema';
import { HeaderSettingsService } from '../../layout/header/header-settings.service';
import { AddButtonService } from '../../core/services/add-button.service';
import { AddAccountModalComponent } from '../../accounts/add-account-modal/add-account-modal.component';
import { NgbDatepickerConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { selectCurrentUser, selectCurrentUserId, selectCurrentUserLocation } from '../../current-user/store/current-user.selectors';
import { selectGetRelatedUsersWithLoadedState, selectUserById } from '../../users/get-related-users/store/get-related-users.selectors';
import { ContentStyleService } from '../../layout/content-style.service';
import { Tag } from '../../accounts/tags/get-tags/get-tags.service';
import { getSlaSVGMarkerIconWithColor, getSVGMarkerIconWithColor, getSVGMarkerIconWithNumberAndColor } from '../../data-access/marker';
import { SearchService } from '../../core/services/search.service';
import { DateRangeFilterService } from '../../core/services/date-range-filter.service';
import { groupBy, isEqual, orderBy } from 'lodash';
import {
  selectGetCompanySettingsSlaRange,
  selectGetCompanySettingsScopeCaptions,
  selectGetCompanySettingsTrackUsersLocation
} from '../../company-settings/get-company-settings/store/get-company-settings.selectors';
import { updateLocalSettingsAction } from '../../local-settings/update-local-settings/store/update-local-settings.actions';
import { getLocalSettingsAction } from '../../local-settings/get-local-settings/store/get-local-settings.actions';
import { Cluster, Marker, SuperClusterAlgorithm } from '@googlemaps/markerclusterer';
import { NgxPermissionsModule, NgxPermissionsService } from 'ngx-permissions';
import { getScopeColor } from '../../shared/pipes/scope-color.pipe';
import { largeMap } from '../../utils/largeMap';
import {
  selectAccountCategoriesWithLoadedState
} from '../../accounts/categories/get-account-categories/store/get-account-categories.selectors';
import { selectGetSortedTagsWithLoadedState } from '../../accounts/tags/get-tags/store/get-tags.selectors';
import {
  selectGetLocalSettings,
  selectGetLocalSettingsBookOfBusinessUISettingsFor
} from '../../local-settings/get-local-settings/store/get-local-settings.selectors';
import { PageMetaService } from '../../core/services/page-meta.service';
import {
  AccountPointSchema,
  AccountScope,
  GetAccountsBaseParamsSchema,
  GetAccountsFilterGroupsSchema,
  getAccountsFilterGroupsSchema
} from '../../models/account';
import { selectGetCompanyIndustry } from '../../company/get-company-users/store/get-company-users.selectors';
import { getScopeCaption } from '../../utils/scope-caption';
import { endOfDay, getUnixTime, startOfDay } from 'date-fns';
import {
  clearGetAllAccountPointsV2Action,
  getAllAccountPointsAction
} from '../../accounts/get-all-account-points/store/get-all-account-points.actions';
import {
  selectGetAllAccountPoints,
  selectGetAllAccountPointsForContext,
  selectGetAllAccountPointsLoading,
  selectGetAllAccountPointsLoadingForContext
} from '../../accounts/get-all-account-points/store/get-all-account-points.selectors';
import { LoaderLineService } from '../../layout/loader-line.service';
import { BookOfBusinessService } from '../../accounts/book-of-business/book-of-business.service';
import { CdkDrag, CdkDragEnd } from '@angular/cdk/drag-drop';
import { calculateClampedPosition } from '../../utils/account-category-chart-position';
import { SlaRange } from '../../models/sla';
import { FilterGroupService } from '../../shared/filter-group/filter-group.service';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { convertFormValueToFilterGroupSchema } from '../../shared/filter-group/filter-group.utils';
import { generateDealAmountRangeFilterGroupList } from '../../deals/utils/amount-range-filter-list';
import { getDealPipelinesAction } from '../../deals/deal-pipelines/store/get-deal-pipelines/get-deal-pipelines.actions';
import { selectGetDealPipelinesData } from '../../deals/deal-pipelines/store/get-deal-pipelines/get-deal-pipelines.selectors';
import { getDealStagesAction } from '../../deals/deal-stages/store/get-deal-stages/get-deal-stages.actions';
import { selectGetDealStages } from '../../deals/deal-stages/store/get-deal-stages/get-deal-stages.selectors';
import { sortBy } from '../../utils/sort-by';
import { mapFilterGroupSchemaToAccountSchema } from '../../utils/filter-group-account';
import { getSlaFilterItems } from '../../utils/sla';
import { GetDealsFilterGroupsSchema } from '../../models/deal';
import { CommonModule } from '@angular/common';
import { CreateAccountModule } from '../../accounts/create-account/create-account.module';
import { AssignToMeModule } from '../../accounts/assign-to-me/assign-to-me.module';
import { UiModule } from '../../shared/ui/ui.module';
import { SharedModule } from '../../shared/shared.module';
import { BulkOperationsModule } from '../../bulk-operations/bulk-operations.module';
import { LetDirective } from '@ngrx/component';
import { LocationInfoWindowContentComponent } from '../location-info-window-content/location-info-window-content.component';
import {
  GetFirstContactForAccountModule
} from '../../accounts/contacts/store/get-first-contact-for-account/get-first-contact-for-account.module';
import { GetAllAccountPointsModule } from '../../accounts/get-all-account-points/get-all-account-points.module';
import { BookOfBusinessComponent } from '../../accounts/book-of-business/book-of-business.component';
import { GetDealPipelinesModule } from '../../deals/deal-pipelines/store/get-deal-pipelines/get-deal-pipelines.module';
import { GetDealStagesModule } from '../../deals/deal-stages/store/get-deal-stages/get-deal-stages.module';
import { Coordinates, TerraDrawSnapshotList } from '../../models/map';
import { DatepickerConfigService, getDatepickerConfig } from '../../core/services/datepicker-config.service';
import { getCurrentLocation$ } from '../../data-access/geolocation';
import LatLngBounds = google.maps.LatLngBounds;

interface CustomMarker {
  title: string,
  position: {
    lat: number,
    lng: number,
  },
  options: {
    icon: string,
  };
  info: AccountPointSchema,
  googleMarker: Marker,
}

type CustomClusterMarker = CustomMarker & {
  position: google.maps.LatLng,
  cluster: Cluster,
}

const getMarker = (categoryColorInMarkersEnabled: boolean, account: AccountPointSchema, size: number, slaRange?: SlaRange) => {
  if (slaRange && size === 1) return getSlaSVGMarkerIconWithColor(slaRange, account.completedStop);

  if (categoryColorInMarkersEnabled && account.accountType) {
    if (size > 1) {
      return getSVGMarkerIconWithNumberAndColor(size, account.accountType.color);
    }
    return getSVGMarkerIconWithColor(account.accountType.color);
  }

  if (size > 1) {
    return getSVGMarkerIconWithNumberAndColor(size, getScopeColor(account.scope));
  }
  return account.scope === AccountScope.child ? '/assets/images/map/pin-child.png'
    : account.scope === AccountScope.prospect ? '/assets/images/map/pin-blue.png'
      : '/assets/images/map/pin-green.png';
};

const convertAccountsFGToDealsFG = (filterGroups: GetAccountsFilterGroupsSchema): GetDealsFilterGroupsSchema =>
  filterGroups.filter((f): f is GetDealsFilterGroupsSchema[number] =>
    [ 'dealUsers', 'dealPipeline', 'dealStage', 'dealAmount' ].includes(f.type)
  );

const ALL_ACCOUNT_POINTS_MASS_ACTION_CONTEXT = 'massAction';

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: [ './location.component.scss' ],
  imports: [
    CommonModule,
    GoogleMapsModule,
    CreateAccountModule,
    AssignToMeModule,
    UiModule,
    SharedModule,
    BulkOperationsModule,
    NgxPermissionsModule,
    LetDirective,
    LocationInfoWindowContentComponent,
    GetFirstContactForAccountModule,
    GetAllAccountPointsModule,
    BookOfBusinessComponent,
    CdkDrag,
    GetDealPipelinesModule,
    GetDealStagesModule,
  ],
  providers: [
    {
      provide: NgbDatepickerConfig,
      useFactory: getDatepickerConfig,
      deps: [ DatepickerConfigService ],
    },
  ]
})
export class LocationComponent implements OnInit, OnDestroy {
  private readonly breadcrumbService = inject(BreadcrumbService);
  private readonly dailyRouteUserIdService = inject(DailyRouteUserIdService);
  private readonly selectedUserService = inject(SelectedUserService);
  private readonly store$ = inject(Store);
  private readonly headerSettingsService = inject(HeaderSettingsService);
  private readonly addButtonService = inject(AddButtonService);
  private readonly modalService = inject(NgbModal);
  private readonly contentStyle = inject(ContentStyleService);
  private readonly searchService = inject(SearchService);
  private readonly dateRangeFilterService = inject(DateRangeFilterService);
  private readonly permissionsService = inject(NgxPermissionsService);
  private readonly pageMetaService = inject(PageMetaService);
  private readonly loaderLineService = inject(LoaderLineService);

  @ViewChild(MapInfoWindow) infoWindow?: MapInfoWindow;
  @ViewChild(GoogleMap) googleMap?: GoogleMap;
  @ViewChildren('markerRef') markerRef?: ComponentRef<MapMarker>;

  bookOfBusinessService = inject(BookOfBusinessService);
  private readonly filterGroupService = inject(FilterGroupService);

  // Fixme: Any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  userLocationMarker?: any;
  // Fixme: Any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  gpsLocationMarker?: any;
  infoWindowContent?: AccountPointSchema;
  infoWindowItems?: AccountPointSchema[];
  detectingGpsLocation = false;
  zoom = 8;
  center: google.maps.LatLngLiteral = {
    lat: 38.8542775,
    lng: -96.0317415,
  };
  options: google.maps.MapOptions = {
    zoomControl: false,
    streetViewControl: false,
    minZoom: 6,
  };
  private terraDraw?: TerraDraw;
  isDrawingActive = signal(false);
  hasDrawingOverlay = signal<boolean>(false);
  private currentPolygonId?: string | number;
  private drawPolygonCoordsSubject = new BehaviorSubject<Coordinates[] | undefined>(undefined);

  currentUserId = this.store$.selectSignal(selectCurrentUserId);
  selectedAccounts = this.store$.selectSignal(selectGetAllAccountPointsForContext(ALL_ACCOUNT_POINTS_MASS_ACTION_CONTEXT));
  computedSelectedAccounts = computed(() => {
    return this.hasDrawingOverlay() ? this.selectedAccounts() : undefined;
  });
  selectedAccountsLoading = this.store$.selectSignal(selectGetAllAccountPointsLoadingForContext(ALL_ACCOUNT_POINTS_MASS_ACTION_CONTEXT));

  filterGroupValue$ = toObservable(this.filterGroupService.value);

  refreshSubject = new EventEmitter<void>();
  clusterEnabledSubject = new BehaviorSubject<boolean>(true);
  clusterEnabled$ = this.clusterEnabledSubject.asObservable();
  mapBoundsSubject = new ReplaySubject<LatLngBounds>(1);
  mapBounds$ = this.mapBoundsSubject.asObservable().pipe(debounceTime(250));
  categoryColorInMarkersEnabledSubject = new BehaviorSubject<boolean>(false);
  categoryColorInMarkersEnabled$ = this.categoryColorInMarkersEnabledSubject.asObservable();
  slaColorInMarkersEnabledSubject = new BehaviorSubject<boolean>(false);
  slaColorInMarkersEnabled$ = this.slaColorInMarkersEnabledSubject.asObservable();
  slaRange$ = this.store$.pipe(select(selectGetCompanySettingsSlaRange));
  markers$ = this.store$.pipe(
    select(selectGetAllAccountPoints),
    filter(inputIsNotNullOrUndefined),
  ).pipe(
    switchMap(accountPoints =>
      combineLatest<[ LatLngBounds, boolean, [ boolean, SlaRange | undefined ] ]>([
        this.mapBounds$,
        this.categoryColorInMarkersEnabled$,
        this.slaColorInMarkersEnabled$.pipe(
          withLatestFrom(this.slaRange$),
        ),
      ]).pipe(
        switchMap(([ mapBounds, categoryColorInMarkersEnabled, [ slaRangeEnabled, slaRange ] ]) => {
          return of(accountPoints).pipe(
            largeMap(accounts =>
              accounts.filter((accountPoint: AccountPointSchema) =>
                new LatLngBounds(mapBounds).contains({
                  // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
                  lng: accountPoint.geoDetails.location?.coordinates[0]!,
                  // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
                  lat: accountPoint.geoDetails.location?.coordinates[1]!,
                })
              )
            ),
            map(accountPoints =>
              Object.entries(
                groupBy(accountPoints, accountPoint =>
                  accountPoint.geoDetails.location?.coordinates.join(',')
                )
              )
            ),
            largeMap(data => {
              return data.map(([ , items ]) =>
                items.map(account => ({
                  title: account.name,
                  position: {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
                    lng: account.geoDetails.location?.coordinates[0]!,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
                    lat: account.geoDetails.location?.coordinates[1]!,
                  },
                  options: {
                    icon: getMarker(categoryColorInMarkersEnabled, account, items.length, slaRangeEnabled ? slaRange : undefined),
                  },
                  info: account,
                  googleMarker: new google.maps.Marker({
                    position: {
                      // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
                      lng: account.geoDetails?.location?.coordinates[0]!,
                      // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
                      lat: account.geoDetails?.location?.coordinates[1]!,
                    },
                  }),
                }))
              ).flat();
            }),
          );
        }),
      )
    ),
    shareReplay(1),
  );
  markersAndClusters$: Observable<{
    markers: CustomMarker[],
  } | {
    markers: CustomMarker[],
    clusterMarkers: CustomClusterMarker[],
  }> = combineLatest([
    this.markers$,
    this.clusterEnabled$,
  ]).pipe(
    map(([ markers, clusterEnabled ]) => {
      if (!clusterEnabled) return { markers };
      const googleMap = this.googleMap?.googleMap;
      if (!googleMap) throw new Error('Unexpected: googleMap is not init');

      const algorithm = new SuperClusterAlgorithm({});
      const overlay = new google.maps.OverlayView();
      overlay.draw = function () {
      };
      overlay.setMap(googleMap);

      // Todo: optimise performance
      const algorithmResult = algorithm.calculate({
        map: googleMap,
        markers: markers.map(marker => marker.googleMarker),
        mapCanvasProjection: overlay.getProjection(),
      });

      const nonClusterMarkers = algorithmResult.clusters
        .filter(cluster => cluster.count === 1)
        .map(cluster =>
          markers.find(m =>
            cluster.markers?.some(clusterMarker => clusterMarker === m.googleMarker)
          )
        ).filter(inputIsNotNullOrUndefined);

      return {
        markers: nonClusterMarkers,
        clusterMarkers: algorithmResult.clusters.filter(cluster => cluster.count > 1).map(cluster => {
          return {
            position: cluster.position,
            options: {
              label: {
                text: String(cluster.count),
                color: '#fff',
                fontSize: '20px',
              },
              icon: {
                url: '/assets/images/cluster/marker.png',
                size: new google.maps.Size(48, 48),
              },
            },
            cluster,
          };
        }),
      };
    }),
    shareReplay(1),
  );
  loading$ = this.store$.pipe(
    select(selectGetAllAccountPointsLoading),
  );
  computedParams$ = combineLatest([
    this.mapBounds$,
    this.searchService.input$.pipe(
      distinctUntilChanged(),
      debounceTime(250),
      filter(search => search.length === 0 || search.length > 2),
    ),
    this.filterGroupValue$,
    this.dateRangeFilterService.filter$.pipe(startWith(undefined)),
    this.selectedUserService.id$,
    this.refreshSubject.pipe(startWith(undefined)),
    this.slaRange$,
  ]).pipe(
    startWith(undefined),
    pairwise(),
    map(([ prevData, data ]) => {
      const [ prevMapBounds ] = prevData || [];
      if (!data) throw new Error('Unexpected: data is undefined');
      const [ mapBounds ] = data || [];
      return { data, refresh: prevMapBounds === undefined || prevMapBounds.toString() === mapBounds.toString() };
    }),
    map(data => {
      const [ mapBounds, search, filterGroupValue, dateRange, selectedUserId, , slaRange ] = data.data;
      const { refresh } = data;

      const filterGroups = filterGroupValue ? getAccountsFilterGroupsSchema.safeParse(
        mapFilterGroupSchemaToAccountSchema(convertFormValueToFilterGroupSchema(filterGroupValue), slaRange)
      ).data : undefined;

      return {
        refresh,
        // eslint-disable-next-line
        params: <GetAccountsBaseParamsSchema>{
          ...(search ? { search } : {}),
          filters: {
            ...(selectedUserId ? { users: [ selectedUserId ] } : {}),
            withLocationOnly: true,
            ...(dateRange ? {
              dateRange: {
                from: getUnixTime(startOfDay(dateRange.from)),
                to: getUnixTime(endOfDay(dateRange.to)),
              }
            } : {}),
            geo: {
              bounds: mapBounds.toJSON(),
            },
          },
          ...(filterGroups ? { filterGroups } : {}),
        },
      };
    })
  );
  bookOfBusinessParams$ = this.computedParams$.pipe(
    debounceTime(250),
    map(({ params }) => params),
  );
  savedBookOfBusinessUISettings$ = this.store$.pipe(
    select(selectGetLocalSettingsBookOfBusinessUISettingsFor('locations'))
  );
  bookOfBusinessOpened = this.bookOfBusinessService.openEvent;
  bookOfBusinessUISettings = signal({
    opened: false,
    position: { x: 10, y: 10 },
    collapsed: false,
    selectedTab: 0,
    inPercent: true,
  });

  computedParams = toSignal(this.computedParams$);
  dealsFilterGroupsParams = computed(() => {
    const filterGroups = this.computedParams()?.params.filterGroups;
    return filterGroups ? convertAccountsFGToDealsFG(filterGroups) : undefined;
  }, { equal: isEqual });

  bookOfBusinessOpenedEffect = effect(() => {
    const opened = this.bookOfBusinessOpened();
    this.bookOfBusinessUISettings.update(s => ({
      ...s,
      ...(opened !== undefined ? { opened } : {}),
    }));
    if (opened !== undefined) {
      this.store$.dispatch(updateLocalSettingsAction({
        payload: {
          accountCategoryChartUISettings: {
            locations: {
              opened,
            },
          },
        },
      }));
    }
  }, { allowSignalWrites: true });

  drawingModeEffect = effect(() => {
    if (this.isDrawingActive()) {
      this.googleMap?.googleMap?.getDiv().classList.add('rmv-map-is-drawing');
    } else {
      this.googleMap?.googleMap?.getDiv().classList.remove('rmv-map-is-drawing');
    }
  });

  private readonly unsubscribe$ = new Subject<void>();

  ngOnInit(): void {
    this.pageMetaService.setTitle('Map');

    const isMobileUser = !!this.permissionsService.getPermission('MOBILE_USER');

    this.store$.dispatch(getLocalSettingsAction());
    this.store$.dispatch(getDealPipelinesAction({ params: { page: 1, size: 1000 } }));
    this.store$.dispatch(getDealStagesAction({}));

    this.headerSettingsService.set({
      search: !isMobileUser,
      userSelect: !isMobileUser,
      filters: false,
      addButton: false,
      calendar: !isMobileUser,
      dailyRouteButton: !isMobileUser,
      bookOfBusiness: true,
    });

    this.breadcrumbService.set({
      name: 'location',
      list: [
        {
          caption: 'Map',
          link: [ '/location' ],
          active: true,
        }
      ]
    });

    this.addButtonService.setMenuItems([
      {
        caption: 'Create account',
        type: 'createAccount',
        click: () => {
        },
      },
      // Todo: Create task without accountID
      {
        caption: 'Create daily route',
        type: 'createDailyRoute',
        click: () => {
        },
      }
    ]);

    this.contentStyle.addClass('--no-padding');

    this.savedBookOfBusinessUISettings$.pipe(filter(inputIsNotUndefined), takeUntil(this.unsubscribe$)).subscribe(uiSettings => {
      this.bookOfBusinessUISettings.update(s => ({
        ...s,
        ...uiSettings,
      }));
    });

    this.addButtonService.addEvent.pipe(takeUntil(this.unsubscribe$)).subscribe(() => this.openAddAccountModal());

    this.store$.pipe(
      select(selectGetAllAccountPointsLoading),
      takeUntil(this.unsubscribe$),
    ).subscribe(loading =>
      this.loaderLineService.set(loading)
    );

    this.computedParams$.pipe(takeUntil(this.unsubscribe$)).subscribe(({ refresh, params }) =>
      this.store$.dispatch(getAllAccountPointsAction({ refresh, params }))
    );

    // Todo: Move to common function
    combineLatest([
      this.store$.pipe(
        select(selectAccountCategoriesWithLoadedState),
        filter(inputIsNotUndefined),
        take(1),
      ),
      this.store$.pipe(
        select(selectGetSortedTagsWithLoadedState),
        filter(inputIsNotUndefined),
        take(1),
      ),
      this.store$.pipe(
        select(selectGetRelatedUsersWithLoadedState),
        filter(inputIsNotNullOrUndefined),
        take(1),
      ),
      this.store$.pipe(
        select(selectGetLocalSettings),
        filter(inputIsNotNull),
        map(localSettings => localSettings.filterGroup?.locations),
        take(1),
      ),
      this.store$.pipe(select(selectGetCompanyIndustry), take(1)),
      this.store$.pipe(select(selectGetCompanySettingsScopeCaptions), take(1)),
      this.store$.pipe(select(selectGetDealPipelinesData)),
      this.store$.pipe(select(selectGetDealStages)),
      this.slaRange$,
    ]).pipe(
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      ),
      takeUntil(this.unsubscribe$),
    ).subscribe(([ categories, tags, relatedUsers, filterGroupSavedData, industry, scopeCaptions, dealPipelines, dealStages, slaRange ]) => {
      const relatedUserItems = relatedUsers.length > 0 ? sortBy(relatedUsers
        .filter(user => !!user.displayName)
        .map(user => ({
          label: user.displayName || '',
          field: user.id,
        })), 'label') : [];

      this.filterGroupService.set({
        scope: 'locations',
        selectedMenu: filterGroupSavedData?.selectedMenu || 0,
        menu: [
          {
            caption: 'Accounts',
            type: 'accounts',
            icon: 'rmv-icon-account-prospects',
          },
          {
            caption: 'Deals',
            type: 'deals',
            icon: 'rmv-icon-deal-v2',
          },
          {
            caption: 'Coverage',
            type: 'sla',
            icon: 'rmv-icon-bob-sla',
          },
        ],
        data: {
          accounts: [
            {
              type: 'type',
              label: 'By Type',
              showMatchAll: false,
              items: [
                {
                  label: getScopeCaption(AccountScope.account, industry, scopeCaptions),
                  field: 'account',
                },
                {
                  label: getScopeCaption(AccountScope.prospect, industry, scopeCaptions),
                  field: 'prospect',
                },
                {
                  label: getScopeCaption(AccountScope.child, industry, scopeCaptions),
                  field: 'child',
                },
                {
                  label: 'Deactivated',
                  field: 'deactivated',
                },
              ],
            },
            {
              type: 'category',
              label: 'By Category',
              showSearch: true,
              showMatchAll: false,
              items: [
                {
                  label: 'No categories',
                  field: 'noCategory',
                },
                ...(categories.length > 0 ? sortBy(categories
                  .filter(category => category.id)
                  .map((category: AccountCategory) => ({
                    label: category.title,
                    field: category.title,
                  })), 'label') : []),
              ],
            },
            {
              type: 'tags',
              label: 'By Tags',
              showSearch: true,
              items: [
                {
                  label: 'No tags',
                  field: 'noTags',
                },
                ...(tags.length > 0 ? sortBy(tags
                  .map((tag: Tag) => ({
                    label: tag.name,
                    field: tag.name,
                  })), 'label') : []) ],
            },
            {
              type: 'users',
              label: 'By Users',
              showSearch: true,
              items: relatedUserItems,
            },
            {
              type: 'primaryOwner',
              label: 'By User primary owner',
              showSearch: true,
              showMatchAll: false,
              items: [ {
                label: 'No primary owner',
                field: 'noPrimaryOwner',
              }, ...relatedUserItems ],
            },
          ],
          deals: [
            {
              type: 'withDeal',
              label: 'By Deal',
              showMatchAll: false,
              items: [
                {
                  label: 'Accounts with a deal',
                  field: 'withDeal',
                }
              ],
            },
            {
              type: 'dealPipeline',
              label: 'By Pipelines',
              showSearch: true,
              showMatchAll: false,
              items: [
                {
                  label: 'Default pipeline',
                  field: 'default',
                },
                ...(dealPipelines && dealPipelines.length > 0 ? dealPipelines.map(pipeline => ({
                  label: pipeline.name,
                  field: pipeline._id,
                })) : []),
              ],
            },
            {
              type: 'dealStage',
              label: 'By Stages',
              showMatchAll: false,
              showSearch: true,
              items: dealStages && dealStages.length > 0 ? dealStages.map(stage => ({
                label: stage.pipeline?.name ? `${ stage.name } (${ stage.pipeline.name })` : stage.name,
                field: stage._id,
              })) : [],
            },
            {
              type: 'dealUsers',
              label: 'By Users',
              items: relatedUsers.length > 0 ? relatedUsers
                .filter(user => !!user.displayName)
                .map(user => ({
                  label: user.displayName || '',
                  field: user.id,
                })) : [],
            },
            {
              type: 'dealAmount',
              label: 'By Amount',
              showMatchAll: false,
              items: generateDealAmountRangeFilterGroupList(),
            },
          ],
          sla: [
            {
              type: 'coverage',
              label: 'By Coverage',
              showMatchAll: false,
              items: getSlaFilterItems(slaRange),
            },
          ],
        },
        openedGroups: filterGroupSavedData?.openedGroups,
        value: filterGroupSavedData?.value || {}
      });
    });

    this.store$.pipe(
      select(selectCurrentUser),
      filter(inputIsNotNullOrUndefined),
      take(1),
      takeUntil(this.unsubscribe$),
    ).subscribe(currentUser => {
      this.selectedUserService.set(currentUser.id);
    });

    this.selectedUserService.id$.pipe(
      filter(inputIsNotNullOrUndefined),
      takeUntil(this.unsubscribe$),
    ).subscribe(id => {
      this.headerSettingsService.set({
        filterGroup: !isMobileUser,
        filterGroupCloseSelectorException: 'app-location',
        addButton: !isMobileUser && id !== 'all',
      });
      if (id === 'all') {
        this.dailyRouteUserIdService.clear();
        return;
      }
      this.dailyRouteUserIdService.set(id);
    });

    this.markers$.pipe(
      filter(inputIsNotNullOrUndefined),
      first(),
      takeUntil(this.unsubscribe$),
    ).subscribe(markers => {
      const [ firstMarker ] = markers.reverse();
      if (firstMarker) {
        this.center = firstMarker.position;
      }
    });

    this.store$.pipe(
      select(selectCurrentUserLocation),
      switchMap(currentLocation =>
        currentLocation ? of(currentLocation) : getCurrentLocation$()
      ),
      take(1),
      takeUntil(this.unsubscribe$),
    ).subscribe(currentLocation => {
      if ('lat' in currentLocation) {
        this.center = {
          lat: currentLocation.lat,
          lng: currentLocation.lng,
        };
        this.userLocationMarker = {
          position: {
            lat: currentLocation.lat,
            lng: currentLocation.lng,
          },
          options: {
            icon: '/assets/images/current-location-marker.svg',
          },
        };
      } else {
        this.center = {
          lat: currentLocation.coords.latitude,
          lng: currentLocation.coords.longitude,
        };
        this.gpsLocationMarker = {
          position: {
            lat: currentLocation.coords.latitude,
            lng: currentLocation.coords.longitude,
          },
          options: {
            icon: {
              url: '/assets/images/current-location-marker.svg',
              anchor: new google.maps.Point(16, 16),
            },
          },
        };
      }
    });

    this.selectedUserService.id$.pipe(
      filter(inputIsNotNullOrUndefined),
      switchMap(id => id ? combineLatest([
        this.store$.pipe(select(selectGetCompanySettingsTrackUsersLocation)),
        this.store$.pipe(select(selectUserById(id))),
      ]) : of([ null, null ])),
      takeUntil(this.unsubscribe$),
    ).subscribe(([ trackUsersLocation, selectedUser ]) => {
      const location = selectedUser?.currentLocation;
      this.userLocationMarker = trackUsersLocation && location ? {
        position: {
          lat: location.lat,
          lng: location.lng,
        },
        options: {
          icon: {
            url: '/assets/images/user-location-marker.svg',
            anchor: new google.maps.Point(16, 16),
          },
        },
      } : null;
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.headerSettingsService.restoreDefaults();
    this.addButtonService.clearMenuItems();
    this.searchService.clear();
    this.selectedUserService.clear();
    this.dailyRouteUserIdService.clear();
    this.filterGroupService.clear();
    this.contentStyle.removeClass('--no-padding');
    this.store$.dispatch(clearGetAllAccountPointsV2Action());
    this.loaderLineService.set(false);
    this.mapBoundsSubject.complete();
    this.bookOfBusinessService.openEvent.set(undefined);
    this.terraDraw?.stop();
  }

  onMapInit(googleMap: google.maps.Map): void {
    fromEventPattern<void>(
      handler => googleMap.addListener('idle', handler),
      (_handler, listener: google.maps.MapsEventListener) => listener.remove()
    ).pipe(
      take(1),
      map(() =>
        new TerraDraw({
          adapter: new TerraDrawGoogleMapsAdapter({ map: googleMap, lib: google.maps }),
          modes: [
            new TerraDrawFreehandMode({
              preventPointsNearClose: true,
              minDistance: 0.00001,
              pointerDistance: 0.00001,
              smoothing: 0.2,
              styles: {
                fillColor: '#0118C4',
                fillOpacity: 0.2,
                outlineColor: '#0118C4',
                outlineWidth: 2,
              }
            }),
            new TerraDrawRenderMode({ modeName: 'idle', styles: {} }),
          ],
        })
      ),
      tap(draw => {
        draw.start();
        draw.setMode('idle');
        this.terraDraw = draw;
      }),
      switchMap(draw => {
        return fromEvent(draw, 'finish').pipe(
          filter(() => this.isDrawingActive()),
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore -- TerraDraw emits a tuple at runtime, but types it as FeatureId.
          map(([ id ]) => id),
          filter(inputIsNotUndefined),
          map(id => {
            const snapshots = draw.getSnapshot() as TerraDrawSnapshotList;
            const feature = snapshots.find(f => f.id === id);
            if (!feature || feature.geometry.type !== 'Polygon') return undefined;

            const ring = feature.geometry.coordinates[0] ?? [];
             
            return { id, coordinates: ring.map<Coordinates>(c => [ c[0] ?? 0, c[1] ?? 0 ]) };
          }),
          filter(inputIsNotUndefined),
        );
      }),
      takeUntil(this.unsubscribe$),
    ).subscribe(({ id, coordinates }) => {
      this.hasDrawingOverlay.set(true);
      this.drawPolygonCoordsSubject.next(coordinates);

      if (this.currentPolygonId !== undefined && this.currentPolygonId !== id) {
        this.terraDraw?.removeFeatures([ this.currentPolygonId ]);
      }
       
      this.currentPolygonId = id;
    });

    combineLatest([
      this.drawPolygonCoordsSubject.pipe(filter(inputIsNotUndefined)),
      this.computedParams$.pipe(
        map(({ params: { filters, filterGroups, search } }) => ({
          search,
          filters: { ...filters, geo: undefined },
          filterGroups,
        })),
        distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
      ),
    ]).pipe(
      filter(() => this.isDrawingActive() && this.hasDrawingOverlay()),
      takeUntil(this.unsubscribe$),
    ).subscribe(([ polygonBounds, params ]) => {
      this.store$.dispatch(getAllAccountPointsAction({
        refresh: true,
        context: ALL_ACCOUNT_POINTS_MASS_ACTION_CONTEXT,
        params: {
          ...params,
          filters: {
            ...params.filters,
            geo: { polygonBounds },
          },
          filterGroups: params.filterGroups,
        },
      }));
    });
  }

  onBoundsChanged(): void {
    const mapBounds = this.googleMap?.getBounds();
    if (mapBounds) {
      this.mapBoundsSubject.next(mapBounds);
    }
  }

  getMyGPSLocation(): void {
    this.detectingGpsLocation = true;
    getCurrentLocation$().pipe(takeUntil(this.unsubscribe$)).subscribe({
      next: position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        this.gpsLocationMarker = {
          position: {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          },
          options: {
            icon: {
              url: '/assets/images/current-location-marker.svg',
              anchor: new google.maps.Point(16, 16),
            },
          },
        };
        this.detectingGpsLocation = false;
      },
      error: () => this.detectingGpsLocation = false,
    });
  }

  openInfoWindow(marker: MapMarker, info: AccountPointSchema) {
    this.markers$.pipe(first()).subscribe(markers => {
      const allRelatedItems = markers.filter(marker =>
        `${ marker.position.lng },${ marker.position.lat }` === info.geoDetails?.location?.coordinates.join(',')
      );
      this.infoWindowContent = info;
      this.infoWindowItems = orderBy(allRelatedItems.map(item => item.info), 'name', 'asc');
      this.infoWindow?.open(marker);
    });
  }

  openAddAccountModal(): void {
    const userId = this.selectedUserService.id || this.currentUserId();
    if (!userId) {
      throw new Error('Unexpected: User is not selected');
    }
    const modalRef = this.modalService.open(AddAccountModalComponent);
    const componentInstance = modalRef.componentInstance as AddAccountModalComponent;
    componentInstance.userId = userId;

    modalRef.result.then(() => this.refresh()).catch(() => {
    });
  }

  trackByFn(index: number, marker: CustomClusterMarker) {
    return marker.cluster.position.toString();
  }

  trackMarkerByFn(index: number, marker: CustomMarker) {
    return marker.info.fbId;
  }

  onAssignedToMe(): void {
    this.infoWindow?.close();
  }

  switchCluster(): void {
    this.clusterEnabledSubject.next(!this.clusterEnabledSubject.value);
  }

  switchCategoryColorInMarkers(): void {
    this.categoryColorInMarkersEnabledSubject.next(!this.categoryColorInMarkersEnabledSubject.value);
  }

  switchSLAColorInMarkers(): void {
    this.slaColorInMarkersEnabledSubject.next(!this.slaColorInMarkersEnabledSubject.value);
  }

  turnOffDrawingMode(): void {
    this.isDrawingActive.set(false);
    this.terraDraw?.clear();
    this.terraDraw?.setMode('idle');
    this.currentPolygonId = undefined;
    this.drawPolygonCoordsSubject.next(undefined);
    this.hasDrawingOverlay.set(false);
  }

  switchDrawingMode(): void {
    if (!this.isDrawingActive()) {
      this.isDrawingActive.set(true);
      this.terraDraw?.setMode('freehand');
      return;
    }
    this.turnOffDrawingMode();
  }

  onSelectedClear(): void {
    this.turnOffDrawingMode();
  }

  onClusterClick(cluster: Cluster): void {
    if (cluster.bounds) {
      this.googleMap?.fitBounds(cluster.bounds);
    }
  }

  refresh(): void {
    this.refreshSubject.next();
  }

  onBookOfBusinessCollapseChange(event: boolean): void {
    this.bookOfBusinessUISettings.update(s => ({
      ...s,
      collapsed: event,
    }));
    this.store$.dispatch(updateLocalSettingsAction({
      payload: {
        accountCategoryChartUISettings: {
          locations: this.bookOfBusinessUISettings(),
        },
      },
    }));
  }

  onBookOfBusinessInPercentChange(event: boolean): void {
    this.bookOfBusinessUISettings.update(s => ({
      ...s,
      inPercent: event,
    }));
    this.store$.dispatch(updateLocalSettingsAction({
      payload: {
        accountCategoryChartUISettings: {
          locations: this.bookOfBusinessUISettings(),
        },
      },
    }));
  }

  onBookOfBusinessSelectedTabChange(event: number): void {
    this.bookOfBusinessUISettings.update(s => ({
      ...s,
      selectedTab: event,
    }));
    this.store$.dispatch(updateLocalSettingsAction({
      payload: {
        accountCategoryChartUISettings: {
          locations: this.bookOfBusinessUISettings(),
        },
      },
    }));
  }

  onBookOfBusinessPositionChange(event: CdkDragEnd, dragBoundaryContainerRef: HTMLDivElement): void {
    this.bookOfBusinessUISettings.update(s => ({
      ...s,
      position: calculateClampedPosition(s.position, event, dragBoundaryContainerRef),
    }));
    this.store$.dispatch(updateLocalSettingsAction({
      payload: {
        accountCategoryChartUISettings: {
          locations: this.bookOfBusinessUISettings(),
        },
      },
    }));
  }
}
